import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { Switchboard } from './subscriptions/switchboard';
import '@awesome.me/webawesome/dist/styles/webawesome.css';
import 'rsuite/dist/rsuite.min.css';
import 'react-datepicker/dist/react-datepicker.css'
import './styles.css'; // important: this should import after rsuite css
//import { PostHogProvider } from 'posthog-js/react';
//import { VITE_PUBLIC_POSTHOG_HOST, VITE_PUBLIC_POSTHOG_KEY } from './configuration';

const queryClient = new QueryClient();

// Import the generated route tree
import { routeTree } from './routeTree.gen'

// Create a new router instance
const router = createRouter({ routeTree })

Switchboard.initialize();

// const posthogOptions = {
//   api_host: VITE_PUBLIC_POSTHOG_HOST
// }

// Register the router instance for type safety
declare module '@tanstack/react-router' { 
  interface Register {
    router: typeof router
  }
} 

// Render the app
const rootElement = document.getElementById('root')!;

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  )
}


      /* Removed for now because of rrweb error. unable to locate .map file.
      <PostHogProvider apiKey={VITE_PUBLIC_POSTHOG_KEY} options={posthogOptions}>
        <RouterProvider router={router} />
      </PostHogProvider>
      */